import { JustificativaCancelamentoAgendaComboEnum as JustificativaEnum } from 'types/enums'
import { composeRules, createValidator, ErrorObject, maxLength, required } from 'util/validation'
import { CancelamentoAgendamentoModel } from 'view/agenda/model-agenda'

export const validateJustificativaCancelamento = createValidator<CancelamentoAgendamentoModel>(
  { justificativa: [required] },
  (values: CancelamentoAgendamentoModel, error: ErrorObject<CancelamentoAgendamentoModel>) => {
    if (values.justificativa === JustificativaEnum.OUTRA) {
      error.justificativaOutra = composeRules([required, maxLength(500)])(values.justificativaOutra)
    }
    return error
  }
)
